<template>
    <div>
        <div class="sub__maxWidth">
            <div class="title">
                <span class="sub-style">키</span>와 <span class="sub-style">몸무게</span>를<br/>
                입력해주세요.
            </div>
            <div class="avatar">
                <img
                    ref="avatar"
                    src="@/assets/images/avatar-tall_all.png"
                    class="avatar-img"
                    alt="아바타"
                />
            </div>
            <div class="input-list">
                <div class="space-around">
                    <div class="sub-title">키</div>
                    <div class="slider">
                        <slide-picker
                            ref="heightPicker"
                            :items="heightList"
                            :initial-index="60"
                            :tabindex="1"
                            suffix="cm"
                            @value="setHeight"
                        />
                    </div>
                </div>
                <div class="space-around">
                    <div class="sub-title">몸무게</div>
                    <div class="slider">
                        <slide-picker
                            ref="weightPicker"
                            :items="weightList"
                            :initial-index="30"
                            :tabindex="2"
                            suffix="Kg"
                            @value="setWeight"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="btn-wrapper">
            <button class="cancel_btn" @click="previous" tabindex="3">＜ 이전</button>
            <button
                :class="this.enableButton ? 'start_enable_btn' : 'start_disable_btn'"
					:disabled="!this.enableButton"
                @click="next"
            >
                다음 ＞
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";
import utils from "@/utils/utils";
import SlidePicker from '../../components/SlidePicker';

export default {
    components: { SlidePicker },
    mixins: [utils],

	data: () => ({
		enableButton: true,
        weightList: Array.range(30, 181),
		heightList: Array.range(100, 211),
		height: 0,
		weight: 0,
	}),

	methods: {
		...mapActions("survey", ["setCheckupTemp", "setStep"]),
		//이전
		previous() {
			this.setStep(2)
			this.$router.push("/checkup/step2");
		},
		//다음
		next() {
			const params = {
				step: 3,
				height: this.height,
				weight: this.weight,
				bmi: this.calcBMI(this.weight, this.height)
			};
			this.setCheckupTemp(params);

			this.setStep(4)
			this.$router.push("/checkup/step4");
		},
        setHeight ({ value }) {
            this.height = value
        },
        setWeight ({ value }) {
            this.weight = value
		},
		async restoreData() {
		    await this.$nextTick()
			if (this.checkUp.heightCm > 0) {
				this.height = this.checkUp.heightCm

				const heightIndex = this.heightList.indexOf(this.height)
				this.$refs.heightPicker.setPosition(heightIndex)
			}
			else {
				this.$refs.heightPicker.setPosition(60)	// default
			}
			if (this.checkUp.weightKg > 0) {
				this.weight = this.checkUp.weightKg

				const weightIndex = this.weightList.indexOf(this.weight)
				this.$refs.weightPicker.setPosition(weightIndex)
			}
			else {
				this.$refs.weightPicker.setPosition(30)	// default
			}
		}
    },
	computed: {
		...mapGetters("survey", {
			checkUp: "checkUp"
		})
	},
	mounted() {
		this.setStep(3)
		this.restoreData()
	}
};
</script>

<style scoped lang="scss">
    .title {
    }
	.slider {
		position: relative;
        max-width: 270px;
		width: 65vw;
		height: 7vh;
		border-radius: 33.5px;
		box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.1), inset -3px -3px 5px 0 rgba(255, 255, 255, 0.5);
		background-image: radial-gradient(circle at 50% 50%, #ffffff, #ffffff 68%, #eaeaea 107%);
	}
    .input-list {
        padding: 2vh 0vh;
    }
	.sub-title {
		font-family: NanumSquare, sans-serif;
		font-size: 20px;
		color: #202020;
	}
	.sub-mask {
		width: 230px;
		height: 66px;
		border-radius: 33.5px;
		box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.1),
			inset -3px -3px 5px 0 rgba(255, 255, 255, 0.5);
		background-image: radial-gradient(
			circle at 50% 50%,
			#ffffff,
			#ffffff 68%,
			#eaeaea 107%
		);
		float: right;
    }
    .avatar-img {

    }
	.start_enable_btn {
		display: inline-block;
		width: 62%;
		height: 44px;
		border-radius: 22px;
		box-shadow: 0 8px 20px -4px rgba(63, 111, 255, 0.5);
		background-color: #3f6fff;
        font-family: NanumSquare, sans-serif;
        color: white;
		border: 0;
		outline: none;
	}

	.start_disable_btn {
		display: inline-block;
		width: 62%;
		height: 44px;
		border-radius: 22px;
		box-shadow: 0 3px 10px -4px rgba(63, 111, 255, 0.5);
		background-color: #a7bdff;
        font-family: NanumSquare, sans-serif;
        color: white;
		border: 0;
		outline: none;
    }

    .cancel_btn {
		display: inline-block;
		width: 33%;
		height: 44px;
		border-radius: 22px;
		margin-right: 5vw;
		background-color: #eaeaea;
        font-family: NanumSquare, sans-serif;
		border: 0;
		outline: none;
	}
</style>
